import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/lib/auth';
import type { ReactNode } from 'react';

export function ProtectedRoute({ children }: { children: ReactNode }) {
  const { user, role, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center text-slate-500">
        Loading…
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  if (role !== 'analyst') {
    return (
      <div className="flex h-screen flex-col items-center justify-center gap-3 text-slate-600">
        <h1 className="text-xl font-semibold">Access pending</h1>
        <p className="max-w-md text-center text-sm">
          Your account ({user.email}) is signed in but has not been granted
          analyst access yet. Ask an admin to add you, then sign out and back in.
        </p>
      </div>
    );
  }

  return <>{children}</>;
}
